import { Roles } from '@client/graphql/__generated__/types';
import { useAppContext } from '~/services/main/contexts/AppContext';

interface OrganizationDemoAccess {
  canViewOrganizationDemo: boolean;
  isCheckingAccess: boolean;
  isDemoEnvironment: boolean;
  isInternalEmployee: boolean;
}

export const useCanViewOrganizationDemo = (): OrganizationDemoAccess => {
  const {
    user,
    selectedOrganization,
    isSelectedOrgAdmin,
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
  } = useAppContext();

  const isInternalEmployee = Boolean(
    user?.roles.includes(Roles.ADMIN) || user?.roles.includes(Roles.EMPLOYEE)
  );
  const isDemoEnvironment = window.ENVS.environment !== 'production';
  const isCheckingAccess = loadingOrganizations || loadingIsSelectedOrgAdmin;
  const canViewOrganizationDemo = Boolean(
    isDemoEnvironment &&
      selectedOrganization &&
      isSelectedOrgAdmin &&
      isInternalEmployee
  );

  return {
    canViewOrganizationDemo,
    isCheckingAccess,
    isDemoEnvironment,
    isInternalEmployee,
  };
};
